import { Linkedin, Instagram, Facebook } from "lucide-react";
import { XLogo } from "../components/icons/XLogo";

// MYSYMP AG / Isidoro Celentano — brand & founder accounts (shown on every page footer)
export const MYSYMP_SOCIALS = [
  { name: "LinkedIn", url: "https://www.linkedin.com/in/isicel/", Icon: Linkedin },
  { name: "Instagram", url: "https://www.instagram.com/isidorocelentano/", Icon: Instagram },
  { name: "Facebook", url: "https://www.facebook.com/isidoro.celentano", Icon: Facebook },
  { name: "X", url: "https://x.com/IsidoroCelenta1", Icon: XLogo },
];

// Wine Pairing — brand accounts (shown in the Wine area)
export const WINE_SOCIALS = [
  { name: "LinkedIn", url: "https://www.linkedin.com/company/wine-pairing-online", Icon: Linkedin },
  { name: "Instagram", url: "https://www.instagram.com/winepairing.online/", Icon: Instagram },
  { name: "X", url: "https://x.com/winepairing_ai", Icon: XLogo },
];
